import React from 'react';

class PackageProgress extends React.Component {
    render() {
        const {current, total} = this.props;

        return <div className="current-set-group">
            <p>Ден <span>{current}</span> от <span>{total}</span></p>
        </div>
    }
}

export default PackageProgress;


// WEBPACK FOOTER //
// ./src/components/Presentation/PackageProgress.js